import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { castDraft } from 'immer';

import { DimensionSet } from '@paragon/contract-library';
import { allComponentDesignsUnloaded, componentDesignsDeletedWithInsertions } from '@paragon/layout-models';
import { forceArray } from '@paragon/utilities';

import { receiveRegenerateFromSettingsResponse } from './componentDesignsSlice';

export interface Dimensions {
  readonly sets: { readonly [key: string]: DimensionSet };
}

const initialState: Dimensions = {
  sets: {},
};

const dimensionsSlice = createSlice({
  name: 'dimensions',
  initialState,
  reducers: {
    setDimensionSets: (state, action: PayloadAction<DimensionSet | readonly DimensionSet[]>) => {
      const dimensionSets = forceArray(action.payload);
      for (const dimensionSet of dimensionSets) {
        state.sets[dimensionSet.guid] = castDraft(dimensionSet);
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(componentDesignsDeletedWithInsertions, (state, action) => {
      for (const componentDesignGuid of action.payload.guids) {
        delete state.sets[componentDesignGuid];
      }
    });

    builder.addCase(allComponentDesignsUnloaded, (state) => {
      state.sets = {};
    });

    builder.addCase(receiveRegenerateFromSettingsResponse, (state, action) => {
      state.sets[action.payload.dimensionSet.guid] = castDraft(action.payload.dimensionSet);
    });
  },
});

export const { setDimensionSets } = dimensionsSlice.actions;
export const dimensions = dimensionsSlice.reducer;
